<template>
  <b-container>
    <TheTitle>U Lifestyle 社群</TheTitle>
    <AdvList></AdvList>
  </b-container>
</template>

<script>
import {
  BContainer,
} from 'bootstrap-vue';

import AdvList from '@/components/advertisement/advList.vue';
import TheTitle from '../../components/TheTitle.vue';

export default {
  components: {
    BContainer,
    TheTitle,
    AdvList,
  },
};
</script>
